import Controller from "./ride.controller";
import template from "./ride.html";

const ride = {
  template,
  controller: Controller,
};

export default ride;



// WEBPACK FOOTER //
// ./src/pages/ride/ride.component.js